// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo-wrap[data-v-096e4c6c] {\n  width: 50px;\n  height: 50px;\n  margin-bottom: 15px;\n}\n.logo-wrap .avatar-img[data-v-096e4c6c] {\n  -o-object-fit: contain;\n     object-fit: contain;\n  height: auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
